// extracted by mini-css-extract-plugin
export default {"root":"lPI6bz"};